'use strict';

module.exports = {
    category: {
        click: 'promo interaction'
    },
    actions: {
        click: 'brand intro welcome banner'
    },
    labels: {
        click: 'welcome modal displayed'
    },
    ecommerce: {
        id: 'brand-intro-welcome-banner',
        name: 'Brand Intro Welcome Banner',
        creative: 'welcome-'
    }
};



// WEBPACK FOOTER //
// ./assets/js/components/Introduction/introduction-trackingConfig.es.js